import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import style from './style.module.less';

const HotkeySectionLineItem = ({ hotkey, name }) => {
  if (Array.isArray(hotkey)) {
    return (
      <>
        <span className={style.keyname}>
          {hotkey.map((key, index) => {
            if (index !== hotkey?.length - 1) {
              return (
                <React.Fragment key={index}>
                  {key}
                  <span className={style['key-separator']}>
                    <FormattedMessage defaultMessage='then' description='hotkey keystroke separator' id='V2oZeF' />
                  </span>
                </React.Fragment>
              );
            }
            return key;
          })}
        </span>
        <span>{name}</span>
      </>
    );
  }
  return (
    <>
      <span className={style.keyname}>{hotkey}</span>
      <span>{name}</span>
    </>
  );
};

HotkeySectionLineItem.propTypes = {
  hotkey: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string, PropTypes.node]).isRequired,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};

export default HotkeySectionLineItem;
